"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddSomeValuesButton = void 0;
var add_some_values_button_component_1 = require("./add-some-values-button.component");
Object.defineProperty(exports, "AddSomeValuesButton", { enumerable: true, get: function () { return add_some_values_button_component_1.AddSomeValuesButton; } });
